module.exports = __webpack_public_path__ + "static/lights9-cc961b19081ca4fbe552d2ae057cae19.jpg";